import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../common/Breadcrumb";
import ServiceDetailsWrapper from "./ServiceDetailsWrapper";

function ServiceDetails() {
  const { serviceName } = useParams();

  // Convert URL slug → Proper Title
  const formatName = (name) => {
    if (!name) return "Service Details";
    return name
      .replace(/-/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <>
      <Breadcrumb pageName={formatName(serviceName)} />
      <ServiceDetailsWrapper />
    </>
  );
}

export default ServiceDetails;